import React from "react";

import { FocusableTooltip } from "../../../../../components/FocusableTooltip";
import { NotAnnualizedInfo } from "../../../NotAnnualizedInfo";
import { irrTextOf, irrTooltipOf, isPeriodIrr } from "../../../utils";
import { IrrFigureProps } from "./types";
import { Figure, Separator, Tag } from "./styles";

// Carries its own leading separator: every caller places it after a gain chip, and a separator
// left behind by an absent IRR would dangle.
export const IrrFigure: React.FC<IrrFigureProps> = ({
  irr,
  isIrrAnnualized,
  basisNote,
}) => {
  const irrText = irrTextOf(irr);
  if (irrText === null) {
    return null;
  }
  const tooltip = irrTooltipOf(basisNote, isIrrAnnualized);
  const isPeriodRate = isPeriodIrr(isIrrAnnualized);

  return (
    <>
      <Separator aria-hidden="true">·</Separator>
      <FocusableTooltip title={tooltip}>
        <Figure $negative={(irr ?? 0) < 0} data-testid="investment-irr">
          {irrText}
          <Tag>IRR</Tag>
        </Figure>
      </FocusableTooltip>
      {isPeriodRate && <NotAnnualizedInfo />}
    </>
  );
};
